<script>
import { createNamespacedHelpers } from 'vuex';
import { SEND_MESSAGE } from '@/store/modules/socket/action-types';

const { mapActions, mapState } = createNamespacedHelpers('socket');

export default {
  data() {
    return {
      // Formatted as following: { <socketMsgType>: handler }
      socketHandlers: {},
    };
  },
  computed: {
    ...mapState({
      lastSocketMessage: state => state.message,
      newSocketMessageAvailable: state => state.newMessageAvailable,
    }),
  },
  watch: {
    newSocketMessageAvailable(newVal, oldVal) {
      if (newVal && !oldVal) {
        const handler = this.socketHandlers[this.lastSocketMessage.msg];
        if (handler) {
          handler(this.lastSocketMessage);
        }
      }
    },
  },
  methods: {
    /**
     * Register socket handler - handler will be called when msgType is received
     * @param {String} type - The type of message that the handler will be call on
     * @param {Function} handler - Function that will be call when socket message is received
     *                             First argument will be the data received
     */
    handleSocketMessage(type, handler) {
      this.socketHandlers[type] = handler;
    },
    ...mapActions({
      sendSocketMessage: SEND_MESSAGE,
    }),
  },
};
</script>
